// extracted by mini-css-extract-plugin
export default {"container":"styles_container__AX1GY","left":"styles_left__Aibg7","text":"styles_text__QCY4w","right":"styles_right__84DXO"};